/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular';
import { PrefsService } from 'src/app/services/prefs.service';

@Component({
  selector: 'app-menu-terms',
  templateUrl: './menu-terms.page.html',
  styleUrls: ['./menu-terms.page.scss']
})
export class MenuTermsPage implements OnInit {
  masterUrl = 'https://projects.rsginc.com/redirect/';
  projectUrl = '';
  url = '';

  constructor(
    private modalCtrl: ModalController,
    private prefs: PrefsService
  ) {}

  openBrowser(url) {
    Browser.open({ url });
  }

  onClickRsgPrivacy() {
    this.openBrowser(this.masterUrl);
  }

  onClickProjectPrivacy() {
    this.openBrowser(this.projectUrl);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ionViewWillEnter() {
    this.prefs.getPromise('studyId').then((res) => {
      this.projectUrl = this.masterUrl + '?studyid=' + res.toString();
    });
  }

  ngOnInit() {}
}
